"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CUSTOM_PROPERTY_NAME = '--aspect-ratio';

var AspectRatio = props => {
  var {
    ratio,
    style,
    children
  } = props,
      otherProps = _objectWithoutPropertiesLoose(props, ["ratio", "style", "children"]); // eslint-disable-line no-unused-vars


  var newStyle = _extends({}, style, {
    // https://github.com/roderickhsiao/react-aspect-ratio/commit/53ec15858ae186c41e70b8c14cc5a5b6e97cb6e3
    [CUSTOM_PROPERTY_NAME]: "(" + ratio + ")"
  });

  return (
    /*#__PURE__*/
    // $FlowFixMe
    _react.default.createElement("div", _extends({
      style: newStyle
    }, otherProps), children)
  );
};

AspectRatio.defaultProps = {
  className: 'react-aspect-ratio-placeholder',
  ratio: 1
};
var _default = AspectRatio;
exports.default = _default;